export type SlideProps = {
  title: string;
  description: string;
  image: string;
};

export const Slide = (props: SlideProps) => null;
